import React from 'react';
import styles from './CustomDivider.module.css';

const CustomDivider = ({labeled = false, label = ''}) => {

  if (!labeled) {
    return <hr className={styles.responsive_divider} />;
  }

  return (
      <div className={styles.custom_divider}>
        <span className={styles.line} />
        <span className={styles.label}>{label}</span>
        <span className={styles.line} />
      </div>
  );
};

export default CustomDivider;